(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      if (!this.header) return;

      this.currentScrollTop = 0;
      this.headerBounds = {};
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-watched"] && !Shopify.designMode) return;
  try {
    
class RecentlyWatchedProducts extends HTMLElement {
  constructor() {
    super();
    this._loaded = false;
    this._storageKey = 'theme:recently-viewed-products';
    this._maxItems = 20; // máximo de productos guardados
  }

  connectedCallback() {
    if (this._loaded) return;
    this._loaded = true;

    const sectionId = this.dataset.section;
    const currentProductId = Number(this.dataset.productCurrent);

    if (!sectionId || Number.isNaN(currentProductId)) {
      this.remove();
      return;
    }

    // --- GUARDAR el producto actual en localStorage ---
    let stored = JSON.parse(localStorage.getItem(this._storageKey) || '[]');

    // eliminar duplicados y añadir al inicio
    stored = [currentProductId, ...stored.filter(id => id !== currentProductId)];

    // limitar la lista
    stored = stored.slice(0, this._maxItems);

    // guardar de nuevo
    localStorage.setItem(this._storageKey, JSON.stringify(stored));

    // --- preparar lista de IDs a mostrar (excluyendo actual) ---
    let items = stored.filter(id => id !== currentProductId);

    if (!items.length) {
      this.remove();
      return;
    }

    // construir query Shopify
    const query = items.map(id => `id:${id}`).join(' OR ');
    const url = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${sectionId}`;

    fetch(url, { priority: 'low' })
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const rendered = doc.querySelector('recently-watched-products');

        if (!rendered || rendered.children.length === 0) {
          this.remove();
          return;
        }

        this.replaceChildren(...document.importNode(rendered, true).childNodes);

        // Cards entram via fetch depois do DOMContentLoaded; reinicia o modal mobile.
        if (typeof window.initQuickVariantSelectors === 'function') {
          window.initQuickVariantSelectors(this);
        }
      })
      .catch(() => {
        this.remove();
      });
  }
}

if (!customElements.get('recently-watched-products')) {
  customElements.define('recently-watched-products', RecentlyWatchedProducts);
}

  } catch(e) { console.error(e); }
})();
})();
